import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-wave-break.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import waveBreak from '../../../assets/bio-section-break.png';

/**
 * The IDB Wave Break component.
 * @element idb-wave-break
 * @extends OutlineElement
 */
@customElement('idb-wave-break')
export class IdbWaveBreak extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <section>
        <img src="${waveBreak}" alt="this is a decorative section break" />
      </section>
    `;
  }
}
